import gql from 'graphql-tag'
import client from '@stores/apollo'

interface DeleteFloorFromManagedLocationsInput {
  id: string
  floorPlanId: string
}

export default function deleteFloorFromManagedLocations(
  input: DeleteFloorFromManagedLocationsInput
): Promise<any> {
  return client.gql.mutate({ mutation, variables: { input } })
}

const mutation = gql`
  mutation deleteFloorFromManagedLocations($input: DeleteLocationAdminEmployeeInput!) {
    deleteLocationAdminEmployee(input: $input) {
      employee {
        id
      }
    }
  }
`
